import React, { useEffect, useState, useCallback } from 'react';
import { CheckmarkIcon, CloseIcon } from '@forgeglobal/design-framework';
import { useStyles } from './style';
import { ValidationWidgetRule } from './ValidationWidgetRule';

interface ValidationWidgetProps<T> {
  title: string;
  value: T;
  rules: ValidationWidgetRule<T>[];
  touched: boolean;
  additional?: string[];
}

const ValidationWidget = ({
  title,
  value,
  rules,
  touched,
  additional,
}: ValidationWidgetProps<typeof value>) => {
  const classes = useStyles();
  const validate = useCallback(
    () => rules && rules.map((rule) => rule.test(value)),
    [rules, value]
  );
  const [valid, setIsValid] = useState(validate());

  useEffect(() => {
    setIsValid(validate());
  }, [value, rules, touched, validate]);

  return (
    <div>
      <span>{title}</span>
      <ul className={classes.ul}>
        {rules &&
          rules.map((rule) => (
            <li
              className={
                touched
                  ? valid && valid[rules.indexOf(rule)]
                    ? classes.validLi
                    : classes.invalidLi
                  : classes.li
              }
              key={rules.indexOf(rule)}>
              {touched && valid && valid[rules.indexOf(rule)] && (
                <CheckmarkIcon className={classes.icon} fontSize="inherit" />
              )}
              {touched && valid && !valid[rules.indexOf(rule)] && (
                <CloseIcon className={classes.icon} fontSize="inherit" />
              )}
              {rule.message}
            </li>
          ))}
        {additional &&
          additional.map((a) => (
            <li
              className={classes.li}
              key={rules.length + additional.indexOf(a)}>
              {a}
            </li>
          ))}
      </ul>
    </div>
  );
};

export default ValidationWidget;
